export { LitePhysics } from "./LitePhysics";

//@ts-ignore
export const version = `__buildVersion`;

console.log(`Galacean Engine Physics Lite Version: ${version}`);
